import { render } from "./Barcomponent.vue?vue&type=template&id=4f88d434"
import script from "./Barcomponent.vue?vue&type=script&lang=js"
export * from "./Barcomponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__